import styled from 'styled-components'

import { ThemeModeType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'

export const Content = styled(Grid)`
    margin-top: 30px;
`

export const Title = styled.p`
    ${(props) => props.theme.typo.displayXS};
    ${(props) => props.theme.fontWeight.medium};
    ${(props) => props.theme.gradient.nector};
    background-clip: text;
    color: transparent;
    text-transform: uppercase;
    word-break: break-word;
    text-align: center;
    margin-bottom: 10px;
`

export const Subtitle = styled.h2`
    ${(props) => props.theme.typo.displayL};
    ${(props) => props.theme.fontWeight.regular};
    text-align: center;
    margin-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
    }
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    line-height: 180%;
    text-align: center;
    padding-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 0px 100px;
        padding-bottom: 80px;
        margin-bottom: -50px;
    }
`

export const Wrapper = styled.div<{ $mode: ThemeModeType }>`
    padding-top: 100px;
    padding-bottom: 100px;

    @media ${(props) => props.theme.query.mobile} {
        padding-left: 20px;
        padding-right: 20px;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 150px;
        padding-bottom: 150px;
    }

    ${Subtitle} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.white : props.theme.color.p500)};
    }

    ${Description} {
        color: ${(props) => (props.$mode === 'Dark' ? props.theme.color.g100 : props.theme.color.g500)};
    }
`
